import { batch } from 'react-redux';
import { POPUP } from 'utils/constants/popup';
import { setPopup } from 'modules/popup/actions';
import {
  UPDATE_CHAT_PARAMS, ADD_MESSAGES, SPLICE_MESSAGES, RESET_CHAT, SET_MESSAGES,
} from './actionTypes';

export const resetChatAction = (roomId) => ({ type: RESET_CHAT, payload: roomId });

export const updateChatParamsAction = ({ roomId, data }) => ({ type: UPDATE_CHAT_PARAMS, payload: { roomId, data } });

export const openChatPopupAction = ({
  roomId, popupType = POPUP.NBA_CHAT, popupData, data,
}) => (dispatch, getState) => {
  const { popup: { popup } } = getState();
  const { type: currentPopupType } = popup || {};
  batch(() => {
    dispatch(updateChatParamsAction({ roomId, data }));
    if (!currentPopupType || ![POPUP.NBA_CHAT, POPUP.ASSISTANCE_CHAT].includes(currentPopupType)) {
      dispatch(setPopup({ type: popupType, data: popupData }));
    }
  });
};

export const setMessagesAction = ({ roomId, data }) => ({ type: SET_MESSAGES, payload: { roomId, data } });
export const addMessagesAction = ({ roomId, data }) => ({ type: ADD_MESSAGES, payload: { roomId, data } });
export const spliceMessagesAction = ({ roomId, data }) => ({ type: SPLICE_MESSAGES, payload: { roomId, data } });
